import React, { ReactNode, useState } from 'react';
import { Carousel } from '@/components/Carousel';
import { CarouselModalContent } from '@/components/CarouselModalContent';
import { Modal } from '@/components/cohort/Modal/Modal';
import { useModalState } from '@/components/cohort/hooks/useModalState';
import styles from './RefinancingCarousel.module.scss';

export type CarouselModalContentType = {
  heading: string;
  paragraph: ReactNode | string;
};

export type CarouselCardContent = {
  title: ReactNode | string;
  subtitle: string;
  backgroundImage: string;
  image: {
    desktop: string;
    mobile: string;
  };
  modalContent: CarouselModalContentType[];
};
interface RefinancingCarouselProps {
  cards: CarouselCardContent[];
}

/* CUTE-227 - Page Carousel Component */
const RefinancingCarousel = ({ cards = [] }: RefinancingCarouselProps) => {
  const [modalContent, setModalContent] = useState<React.JSX.Element>(<> </>);
  const { isOpen, openModal, closeModal } = useModalState();

  const formatCarouselCardContent = ({
    backgroundImage,
    title,
    subtitle,
    image,
    modalContent: cardModalContent,
  }: CarouselCardContent) => ({
    backgroundImage,
    title,
    subtitle,
    onClick: () => {
      openModal();
      setModalContent(<CarouselModalContent image={image} content={cardModalContent} />);
    },
  });

  const formattedContent = cards.map(formatCarouselCardContent);

  return (
    <>
      <Modal open={isOpen} closeModal={closeModal}>
        {modalContent}
      </Modal>

      {/* CUTE-227 - TODO - Sort out containers and width resposive 16 < view-lg and 32 > view-lg */}
      <div className={styles.container}>
        <Carousel items={formattedContent} />
      </div>
    </>
  );
};

export default RefinancingCarousel;
